import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Injectable } from "@angular/core";

import { AuthService } from "./authServices";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isSessionExpiredDueToInactivity()) {
      this.authService.clearSessionExpiredState();
    }

    const isAuth = this.authService.getIsAuth();
    if (isAuth) {
      if (this.authService.getIsPasswordChangeRequired()) {
        this.router.navigate(["/login/change-password"]);
      } else {
        this.router.navigate(["/dashboard"]);
      }
      return false;
    }
    return true;
  }
}
